import * as GlobalActionTypes from 'constants/ActionTypes';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').Filters>} */
const initialState = {};

const clearData = () => initialState;

/**
 * @param {import('modules/statistics/types').Filters} state
 * @param {import('modules/statistics/types').AddFilterAction} action
 * @returns {import('modules/statistics/types').Filters}
 */
const addFilter = (state, { payload: { questionFilterId, choice } }) => ({
  ...state,
  [questionFilterId]: [...(state[questionFilterId] ?? []), choice],
});

/**
 * @param {import('modules/statistics/types').Filters} state
 * @param {import('modules/statistics/types').RemoveFilterAction} action
 * @returns {import('modules/statistics/types').Filters}
 */
const removeFilter = (state, { payload: { questionFilterId, choice } }) => ({
  ...state,
  [questionFilterId]: (state[questionFilterId] ?? []).filter(item => item !== choice),
});

export default createReducer(initialState, {
  [types.SET_QUESTION_MODEL_STATISTICS_ID]: clearData,
  [GlobalActionTypes.SET_DEALER_STATISTICS_PERIOD]: clearData,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: clearData,
  [types.ADD_FILTER_QUESTION_MODEL_STATISTIC]: addFilter,
  [types.REMOVE_FILTER_QUESTION_MODEL_STATISTIC]: removeFilter,
  [types.REMOVE_ALL_FILTER_QUESTION_MODEL_STATISTIC]: clearData,
  [GlobalActionTypes.SELECT_DEALER]: clearData,
  [SELECT_GROUP]: clearData,
});
